Original file is fields/field_group.html
ng-init="initInnerFieldGroup(field)" - didn't implement as no example to set listener
<template>
  <div :class="{'my-6 p-6 bg-white rounded-lg border border-gray-200 flex-col inline-flex w-full gap-4': !sidebar}" v-if="((form_preview||injectFormPreview) && !contact) || fieldGroupIsVisible" v-show="hasVisibleFields(field, ['edit_access','readonly_access'], current_user)">
  <blocking-field-block :field_id="field.datahash._js_id">
    <!-- / Field group label -->
  <h4 v-if="!sidebar">
    <span>
      <span v-if="field.type === 'DescriptiveText'" class="descriptive-text" v-html="$sanitize($tr(field.datahash, 'label'))" />
      <span v-else>
        {{$tr(field.datahash, 'label')}}
      </span>
    </span>
  </h4>
  <!-- / Field group sub fields -->
  <div :id="`field-${field.index}`" v-for="(subfield, index2) in field.fields">
    <template v-if='display_type === "edit"'>
      <div v-if="hasFeature('field-access-levels')">
        <div v-if="use_field_access_levels">
          <field-edit :field="subfield" :position="index2" v-if="hasAccessLevel(subfield, 'edit_access', current_user)" />
          <field-show :form_preview="form_preview" :index="index" :cst="cst"
                      :form="safeForm" :form_result="formResult||form_result" :field="subfield" v-if="hasAccessLevel(subfield, 'readonly_access', current_user)" />
        </div>
        <div v-else>
          <field-edit :field="subfield" :position="index2" />
        </div>
      </div>
      <div v-if="!hasFeature('field-access-levels')">
        <field-edit :field="subfield" :position="index2" />
      </div>
    </template>
    <template v-else-if='display_type === "show"'>
      <div v-if="hasFeature('field-access-levels')">
        <div v-if="use_field_access_levels">
          <div v-if="!sidebar || subfield.datahash.sidebar">
            <field-show :form_preview="form_preview" :index="index" :cst="cst" :form="form" :form_result="form_result" :field="subfield" v-if="hasAccessLevel(subfield, 'edit_access', current_user)"></field-show>
            <field-show :form_preview="form_preview" :index="index" :cst="cst" :form="form" :form_result="form_result" :field="subfield" v-if="hasAccessLevel(subfield, 'readonly_access', current_user)"></field-show>
          </div>
        </div>
        <div v-if="!use_field_access_levels">
          <div v-if="sidebar ? (subfield.datahash.sidebar === true) && fieldGroupIsVisible : !sidebar">
            <field-show :form_preview="form_preview" :index="index" :cst="cst" :form="form" :form_result="form_result" :field="subfield"></field-show>
          </div>
        </div>
      </div>
      <div v-else-if="!sidebar || subfield.datahash.sidebar">
        <field-show :form_preview="form_preview" :index="index" :cst="cst" :form="form" :form_result="form_result" :field="subfield" ></field-show>
      </div>
    </template>
  </div>
  </blocking-field-block>
</div>
</template>
<script>
// import { defineAsyncComponent } from 'vue'

import { hasAccessLevel, hasAccessForFields } from '../index_js.js'
import { useFormResultStore } from '../../stores/form_result';
import blockingFieldBlock from './blocking_field_block.vue';
import {contactSubTypes} from "../../stores/contact_sub_types";
import {forms} from '../../stores/forms';
// difference from app/assets/angular/templates/forms/_fields_display.html is very small

export default {
  components: {
    blockingFieldBlock,
  },
  props: {
    cst: {},
    field: {},
    form_result: {},
    display_type: {type: String},
    sidebar: {type: Boolean, required: false},
    form_preview: {type: Boolean},
    form: {type: Object},
    contact: {type: Object, required: false},
    index: {type: Number, required: false},
  },
  inject: {'allFields':{}, 'formResultData':{}, formResult: {}, injectFormPreview: {from: 'form_preview'}},
  data: ()=>({
    hasAccessLevel,
    current_user: null,
    dataForm: {},
    formResultStore:null,
    settings: {},
  }),
  computed: {
    fields(){
      return this.cst .contact_sub_type.field_group.fields
    },
    safeForm(){ return this.form || this.formResultData.form.value },
    //If this is a form that came from a shared program we should ignore any access levels as they are based on Permissions of the other agencies
    use_field_access_levels(){ return this.settings.use_field_access_levels },
    fieldGroupIsVisible() {
      this.formResultStore
      return this.formResultStore.fieldGroupIsVisible(this.field, this.allFields)
    },
  },
  created () {
    this.$auth.authUser().then(u=> this.current_user = u)
    if (this.formResult) this.formResultStore = useFormResultStore(this.formResult);

    if (this.safeForm.contact_type) {
      contactSubTypes().settings(this.safeForm.uid).then(data=> {
        this.settings = data
      })
    }else{
      forms().settings(this.safeForm.uid).then(data=> {
        this.settings = data
      })
    }
  },
  methods: {
    //copying here as original cannot be extracted because of permissions
    hasVisibleFields(fieldGroup, accessLevels, user){
      return this.hasFeature('field-access-levels')
      && this.use_field_access_levels
          ? hasAccessForFields(accessLevels, user, fieldGroup.fields)
          : true;
    },
  }
}
</script>